import React, { useId } from "react";

function GreyStar({ width = "20px", className = "" }) {
  const id = useId();
  const gradientId = `gold-star-gradient-${id}`;

  return (
    <svg
      width={width}
      height={width}
      className={className}
      viewBox='0 0 293 281'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M217.205 278.283L153.464 244.346C148.545 241.801 142.567 241.609 137.667 244.404L73.7459 277.741C61.1743 284.194 46.619 273.569 49.1298 259.678L61.6784 188.728C62.7254 183.172 60.7838 177.626 56.9263 173.583L5.50617 122.943C-4.56392 112.942 1.13725 95.8361 15.0061 93.8632L86.4841 83.7773C92.0313 82.9027 96.9286 79.4677 99.2589 74.5472L131.471 9.93259C137.829 -2.69102 155.761 -2.54318 161.998 10.0343L193.617 74.842C195.984 79.9589 200.906 83.3579 206.46 84.1918L277.8 94.8221C291.684 96.9069 297.298 114.185 287.086 123.833L235.182 173.997C231.14 177.856 229.239 183.629 230.113 188.965L241.901 260.039C244.3 273.912 229.609 284.431 217.203 277.856L217.205 278.283Z'
        fill={`url(#${gradientId})`}
      />
      <path
        opacity='0.52'
        d='M74.8062 170.733C73.0859 167.323 70.9402 164.341 68.1549 161.574L34.518 128.595C31.0898 125.191 29.7903 120.07 31.2674 115.366C32.7445 110.662 36.7879 107.23 41.6955 106.572L88.2095 99.9943C99.0912 98.4595 108.673 91.5903 113.546 81.7485L134.526 39.5994C136.645 35.1068 141.118 32.5276 146.028 32.5096C150.938 32.4916 155.431 35.2515 157.582 39.7285L168.122 61.2598L164.925 62.7665L154.386 41.2351C152.88 38.0372 149.67 36.1269 146.041 36.1402C142.412 36.1535 139.431 38.0865 137.735 41.2962L116.755 83.4452C111.244 94.3572 100.812 101.87 88.6497 103.623L42.1357 110.201C38.5082 110.641 35.7417 113.001 34.6869 116.421C33.632 119.842 34.4992 123.47 37.0695 125.809L70.7064 158.789C73.706 161.768 76.0667 165.176 78.0013 168.8L74.8054 170.52L74.8062 170.733Z'
        fill='white'
      />
      <path
        opacity='0.52'
        d='M81.3276 252.937C78.9793 252.946 76.6272 251.886 74.7004 250.399C70.6334 247.424 68.6942 242.519 69.5309 237.817L75.8052 202.342L79.4366 202.97L73.1623 238.445C72.5352 242.078 73.8278 245.276 76.8243 247.401C79.8207 249.526 83.4506 249.726 86.6472 248.219L128.409 226.496C139.063 220.904 152.299 221.069 162.993 226.583L204.488 248.642C207.697 250.338 211.325 250.111 214.306 247.965C217.287 245.818 218.555 242.397 218.115 238.981L210.473 192.452C208.507 180.286 212.519 168.098 221.24 159.524L255.063 126.724C257.615 124.152 258.456 120.732 257.376 117.319C256.296 113.906 253.513 111.567 249.881 110.94L203.317 103.849C198.405 103.226 193.916 101.534 189.85 98.9864L191.76 95.776C195.611 98.111 199.672 99.5911 203.944 100.216L250.508 107.307C255.421 108.143 259.276 111.332 260.788 116.239C262.3 120.932 260.824 126.063 257.421 129.492L223.598 162.291C215.728 170.009 211.926 181.128 213.886 191.799L221.529 238.328C222.401 243.237 220.283 247.943 216.238 250.948C212.192 253.739 207.07 254.185 202.579 251.852L161.083 229.793C151.458 224.703 139.503 224.533 129.915 229.694L88.1533 251.417C86.0224 252.493 83.4631 253.143 81.1141 252.938L81.3276 252.937Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1='21.5666'
          y1='127.196'
          x2='278.394'
          y2='141.31'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#A9A9A9' />
          <stop offset='1' stopColor='#DADADA' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GreyStar;
